module.exports = __webpack_public_path__ + "static/media/talent-feature-interview-reminder@2x.f68fc7dc.png";